import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';
import DataRepository from '../../../app/data-framework/data-repository';
import DataProvider from '../../../app/data-framework/data-provider';
import templateMarkup from 'raw-loader!./roomgrid-widget.html';



    function RoomGridWidget(params) {
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        this.panelTemplate = params.panelTemplate;
        this.widgetSignals = params.widgetSignals;

        this.dataRepository = DataRepository.getInstance();
        this.dataProvider = DataProvider.getInstance();

        this.availableEndpointsSubscription = null;

        this.rowClickCallback = _.bind(this.rowClickHandler, this);

        this.typeaheadOptions = DataRepository.getInstance().getRoomMetadata().filterConditions;
    }

    function getDataForModal() {
        return ko.dataFor($('#updateroom-modal')[0].firstChild);
    }

    RoomGridWidget.prototype = {
        rowClickHandler: function(row, columnIndex) {
            var data = this.observableData();

            if (!_.isEmpty(data) && data.rowProperties[columnIndex] === 'edit') {
                this.editRoom(row);
            }
        },
        editRoom: function(room) {
            var roomModal = getDataForModal();

            roomModal.show(_.assignIn({}, room, {
                saveCallback: _.bind(this.editRoomCallback, this),
            }));
        },
        editRoomCallback: function() {
            if (this.widgetSignals) {
                this.widgetSignals.dataRequested.dispatch();
            }
            this.dataProvider.refreshDataSources(this.panelTemplate.dataSources);
        }
    };

    export default { viewModel: RoomGridWidget, template: templateMarkup };
